export default "__VITE_ASSET__BaFgenGn__"